export default __webpack_public_path__ + "static/media/education1.5cc06d30.png";